import { render, staticRenderFns } from "./FormSelectOptionGroup.vue?vue&type=template&id=53f8f73c&"
import script from "./FormSelectOptionGroup.vue?vue&type=script&lang=js&"
export * from "./FormSelectOptionGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports